'use client';

import { type ReactNode } from 'react';

import { VendorShareContext } from '@/common/contexts/vendor-share.context';

interface VendorContextWrapperProps {
  vendorName: string;
  vendorSlug: string;
  vendorSharable: boolean;
  isStore: boolean;
  children: ReactNode;
}

export default function VendorContextWrapper({
  vendorName,
  vendorSlug,
  vendorSharable,
  isStore,
  children,
}: VendorContextWrapperProps) {
  return (
    <VendorShareContext.Provider
      value={{
        vendorName,
        vendorSlug,
        vendorSharable,
        isStore,
      }}
    >
      {children}
    </VendorShareContext.Provider>
  );
}
